import { GHLLanguageKeys as o } from "./ghl-ui.es285.js";
import e from "./ghl-ui.es809.js";
const r = {
  name: o.norwegian,
  locale: e
};
export {
  r as date_no
};
